import { ReactElement, useMemo } from 'react'
import { Form } from '@ui/forms'
import TimberFrameFormFields from './TimberFrameFormFields'
import { getTimberFrameLayerSchema } from './schema'
import { formStateToLayer, layerToFormState } from './utils'

const deriveVariant = ({
  assemblyKind,
  assemblyUsageType,
  defaultValues,
}: {
  assemblyKind?: AssemblyKind
  assemblyUsageType?: AssemblyTypes
  defaultValues?: Layer
}): TimberFrameLayerVariant => {
  const timberLayer = defaultValues as TimberFrameLayer | undefined

  if (timberLayer?.kind === 'timber-frame-layer-roof-ceiling') return 'roof-ceiling'
  if (timberLayer?.kind === 'timber-frame-layer-wall') return 'wall'

  if (
    assemblyKind === 'timber-frame-assembly-roof' ||
    assemblyKind === 'timber-frame-assembly-ceiling'
  )
    return 'roof-ceiling'
  if (assemblyKind === 'timber-frame-assembly-wall') return 'wall'
  if (assemblyKind === 'timber-frame-assembly') {
    if (assemblyUsageType === 'Roof' || assemblyUsageType === 'Ceiling') return 'roof-ceiling'
    return 'wall'
  }

  if (assemblyUsageType === 'Roof' || assemblyUsageType === 'Ceiling') return 'roof-ceiling'

  return 'wall'
}

const TimberFrameLayerForm = ({
  id,
  onSubmit,
  defaultValues,
  assemblyKind,
  assemblyUsageType,
}: LayerFormProps): ReactElement => {
  const variant = useMemo(
    () => deriveVariant({ assemblyKind, assemblyUsageType, defaultValues }),
    [assemblyKind, assemblyUsageType, defaultValues],
  )

  const schema = useMemo(() => getTimberFrameLayerSchema(variant), [variant])

  const defaults = useMemo(() => {
    if (defaultValues) {
      return layerToFormState(defaultValues as TimberFrameLayer, variant)
    }
    return schema.getDefault()
  }, [defaultValues, schema, variant])

  return (
    <Form
      id={id}
      validationSchema={schema}
      defaultValues={defaults}
      onSubmit={values => onSubmit(formStateToLayer(values as TimberFrameLayerFormState, variant))}
    >
      <TimberFrameFormFields variant={variant} />
    </Form>
  )
}

export default TimberFrameLayerForm
